import React from 'react'
import { Radio as AntRadio } from 'antd'
import PropTypes from 'prop-types'
import { compose } from 'ramda'
import withStyle from './Radio.style.js'

const Radio = ({ disabled, checked, onClick, children, value, className }) => (
  <AntRadio
    checked={checked}
    disabled={disabled}
    onClick={onClick}
    value={value}
    className={className}
  >
    {children}
  </AntRadio>
)

Radio.propTypes = {
  /** Passed to a single Radio to determine whether the radio is selected or not */
  checked: PropTypes.bool,
  /** Passed to a single Radio or child of a Radio with the `group` prop set to disable an individual Radio */
  disabled: PropTypes.bool,
  /** passed to a parent Radio to enforce group behavior */
  group: PropTypes.bool,
  /** if (group) passed to parent to handle selection of children else passed to radio to handle selection */
  onClick: PropTypes.func,
  /** if (group) children should be individually declared Radio components with `value` and `display properties set
  else this is the information displayed next to the Radio affordance */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
    PropTypes.number,
  ]),
  /** javascript name applied to the Radio elements for use by click handlers */
  name: PropTypes.string,
  /** default value supplied to parent Radio to present a default selection to the users */
  defaultValue: PropTypes.any,
  /** if (group) the value that matches the selected child Radio else the javascript value applied to Radio Elements for use by click handlers */
  value: PropTypes.any,
  /** css className property */
  className: PropTypes.string,
  /** boolean property if set displays child Radio/Label pairs in vertical alignment */
  vertical: PropTypes.bool,
}

export default compose(withStyle)(Radio)
